import {
    Directive,
    HostListener,
    ElementRef,
    Optional
} from '@angular/core';
import {FormGroupDirective} from '@angular/forms';

import {InvalidControlScrollContainerDirective} from './invalid-control-scroll-container.directive';

@Directive({
    selector: '[appInvalidControlScroll]',
  standalone: true
})
export class InvalidControlScrollDirective {
    private get containerEl(): any {
        return this.scrollContainerDir ? this.scrollContainerDir.containerEl : window;
    }

    constructor(
        private el: ElementRef,
        private formGroupDir: FormGroupDirective,
        @Optional()
        private scrollContainerDir: InvalidControlScrollContainerDirective
    ) {
    }

    @HostListener('ngSubmit') onSubmit(): void {
        if (this.formGroupDir.control.invalid) {
            this.scrollToFirstInvalidControl();
        }
    }

    private scrollToFirstInvalidControl(): void {
        const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
            '.invalid-control'
        );
        setTimeout(() => {
            firstInvalidControl.scrollIntoView();
        });
    }
}
